import { defineComponent, reactive, ref, watch, toRefs, onMounted } from "vue";
import { weChatrequest } from '@/utils/request';
import pie from './pie';
export default defineComponent({
  components: {
    pie
  },
  name: '',
  props: {
    cellData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(props) {
    const state = reactive({
      chartData: [{
        name: '正常',
        value: 10
      }, {
        name: '离线',
        value: 20
      }, {
        name: '告警',
        value: 30
      }],
      pData: {
        '设备总数': 0,
        '正常': 0,
        '离线': 0,
        '告警': 0
      }
    });
    const methods = reactive({
      getChart: () => {
        // 告警分类统计
        weChatrequest({
          url: "/api/v1/actuator/actStatus",
          method: "get"
        }).then(res => {
          if (res.code == 0) {
            let chartData = [];
            state.pData = res.data;
            for (const key in res.data) {
              chartData.push({
                'name': key,
                'value': res.data[key]
              });
            }
            chartData.shift();
            state.chartData = chartData;
            console.log(state.chartData, ' state.chartData==');
          } else {
            state.chartData = [];
          }
        });
      }
    });
    onMounted(() => {
      methods.getChart();
    });
    return {
      ...toRefs(state),
      ...toRefs(methods)
    };
  }
});